import React, {Component} from 'react';
import ReactSummernote from 'react-summernote';
import 'react-summernote/dist/react-summernote.css'; // import styles
import 'react-summernote/lang/summernote-ru-RU'; // you can import any other locale
import $ from "jquery";
import {Col, Row, Input} from 'reactstrap';

import {Translate} from "react-localize-redux";

// Import bootstrap(v3 or v4) dependencies
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/tooltip';
import 'bootstrap/dist/css/bootstrap.css';

class PlanDescriptionEditorSN extends Component {

    constructor(props) {
        super(props);

        this.state = {
            disabled: props.disabled,
            languageCode: props.languageCode,
            title: props.title,
            languageName: props.languageName,
            description: props.description
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleTitleChange = this.handleTitleChange.bind(this);
    }

    componentWillReceiveProps(props) {
        this.setState({
            disabled: props.disabled,
            languageName: props.languageName,
            languageCode: props.languageCode,
            title: props.title,
            description: props.description
        });
    }

    /**
     * Handles the description changes
     * @param event
     */
    handleChange(e) {
        this.setState({
            description: e
        },()=>{
            this.props.updateParent(this.state);
        });
    }

    /**
     * Handles title change
     * @param event
     */
    handleTitleChange(e) {
        this.setState({
            title: e.target.value
        },()=>{
            this.props.updateParent(this.state);
        });
    }


    render() {

        return (
            <Row>
                {
                    <Col sm={{size: 12}}>
                        <div>
                            <h4><Translate id="plan-description-editor.description-for-language"/>{this.state.languageName}
                            </h4>
                            <p><Translate id="plan-description-editor.title"/></p>
                            <Input disabled={this.state.disabled} type="text" onChange={this.handleTitleChange}
                                    value={this.state.title}/>
                            <p><Translate id="plan-description-editor.instruction"/></p>
                            <ReactSummernote
                                disabled={this.state.disabled}
                                value={this.state.description}
                                options={{
                                    lang: 'en-US',
                                    height: 350,
                                    dialogsInBody: true,
                                    toolbar: [
                                        ['style', ['style']],
                                        ['font', ['bold', 'underline', 'clear']],
                                        ['fontname', ['fontname']],
                                        ['para', ['ul', 'ol', 'paragraph']],
                                        ['table', ['table']],
                                        ['insert', ['link', 'picture', 'video']],
                                        ['view', ['fullscreen', 'codeview']]
                                    ]
                                }}
                                onChange={this.handleChange}
                            />
                        </div>
                    </Col>
                }
            </Row>
        );
    }
}

export default PlanDescriptionEditorSN;